export interface IDashboardBenchmarkSalesResponse {
  intervalLabel: string
  displayText: string
  sales: number
  salesFormatted: string
  incomeIndex: number
  topSalesAverage: number
  topSalesAverageFormatted: string
  bottomSalesAverage: number
  bottomSalesAverageFormatted: string
}
